<template>
  <div id="metrics" class="metrics">
    <transition name="fade" appear>
      <div class="card metrics-card" v-if="metrics.length > 0">
        <div class="row">
          <div class="col"><h4>{{ name }}</h4></div>
          <div v-if="lastUpdate" class="col last-update text-center"><strong>Updated:</strong> {{ showLastUpdate(lastUpdate) }}</div>
          <div class='col'>
            <div class="text-right">
              <div v-if="metricProperties.length > 1" class="btn-group dropdown">
                <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ metricProperty }}
                </button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                  <button v-for="prop in metricProperties" :key="prop" class="dropdown-item" type="button" v-on:click="setProperty(prop)">{{ prop }}</button>
                </div>
              </div>
              <div class="btn-group dropdown">
                <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ period }}
                </button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                  <button class="dropdown-item" type="button" v-on:click="setPeriod(setMenuOption(period))">{{ setMenuOption(period) }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
          <transition-group class="chart" name="list" appear>
            <template v-for="(metric,index) in metrics">
              <div class="bar" v-bind:class="[ {active: ((metric.date || metric.deploy.date) === date)}]" v-on:click="setDate(metric, index)" :style="{'height': barHeight(metric, metrics)+'%'}" v-bind:key="index">
                <div class="labels">
                  <div class="count">
                    {{ metric[metricProperty] }}
                  </div>
                  <div class="label">
                    {{ formatLabel(metric.label, period) }}
                  </div>
                </div>
              </div>
            </template>
          </transition-group>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MetricGraph',
  props: {
    metrics: {
      type: Array,
      default: () => []
    },
    metricProperties: {
      type: Array,
      default: () => ['count']
    },
    metricProperty: {
      type: String,
      default: () => 'count'
    },
    name: {
      type: String
    },
    date: {
      type: String
    },
    period: {
      type: String
    },
    lastUpdate: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    ...mapGetters([
      'id_token',
      'settings'
    ])
  },
  methods: {
    barHeight: function (metric, metrics) {
      let list = metrics.map(metric => metric[this.metricProperty])
      let max = Math.max(...list)
      return (max > 0) ? (metric[this.metricProperty] * 99 / max + 1) : 1
    },
    setPeriod: function (period) {
      this.$emit('updateMetric', {eventType: 'period', data: {period: period}})
    },
    setProperty: function (metricProperty) {
      this.$emit('updateMetric', {eventType: 'metricProperty', data: {metricProperty: metricProperty}})
    },
    setDate: function (metric, metricIndex) {
      this.$emit('updateMetric', {
        eventType: 'date',
        data: {
          date: (metric.date || metric.deploy.date),
          lastUpdate: (metric.lastUpdate || metric.last_update || metric.date || metric.deploy.date),
          metricIndex: metricIndex
        }
      })
    },
    setLabels: function () {
      if (this.period === 'week') {
        this.labels = ['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun']
      } else if (this.period === 'month') {
        var count = this.$moment(this.date, 'YYYY-MM').daysInMonth()
        this.labels = Array.from({length: count}, (v, k) => k + 1)
      }
    },
    showLastUpdate: function (lastUpdate) {
      var date = this.$moment.unix(parseInt(lastUpdate))
      if (date.isValid()) {
        return date.format('MMM Do, h:mm a')
      } else if (lastUpdate == null || lastUpdate === 'unknown') {
        return 'report not found'
      } else {
        return 'unknown'
      }
    },
    friendlyDuration: function (seconds) {
      // use dummy date to calulate the amount of hours, minutes and seconds from seconds
      // dosn't matter what 2015-01-01 is
      var format = 's [seconds]'
      if (seconds > 59) {
        format = 'm [minutes] ' + format
      }
      if (seconds > 3599) {
        format = 'H [hours] ' + format
      }
      return this.$moment('2015-01-01').startOf('day').seconds(seconds).format(format)
    },
    formatLabel: function (label, period) {
      if (this.settings.global.weekNumbers) {
        return label
      } else if (period === 'week') {
        return this.$moment().day('Monday').isoWeek(label).format('DD/MM')
      } else {
        return this.$moment().month(label).format('MM')
      }
    },
    capital: function (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    setMenuOption: function (selected) {
      return (selected === 'week') ? 'month' : 'week'
    }
  }
}
</script>

<style scoped src='../assets/stylesheet/metric-graph.css'></style>



// WEBPACK FOOTER //
// src/components/MetricGraph.vue